import fetch from 'isomorphic-unfetch';

import { apiHeaders, appendSessionIdHeader } from '../generic';

export default class LoggyApis {
  static pushLoggyEvent = async (data) => {
    let headers = apiHeaders();

    await appendSessionIdHeader(headers);
    const url = process.env.LOGGY_URL;
    const res = await fetch(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(data),
      keepalive: true
    });

    return res;
  };
}
